import ServicePage from "./ServiceTemplate";
export default function HotStone() { return <ServicePage serviceId="hot-stone" />; }
